import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { AppDispatch } from "../../../../store/app";
import { useDispatch } from "react-redux";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import SVGIcon from "../../../../utils/SVGIcon";
import dayjs, { Dayjs } from "dayjs";
import { CONSTANT } from "../../../../config/Constant";
import { addNumberManagementNumberAttributesReport } from "../../../../store/NumberManagementNumberAttributesReportSlice";

const AddNumberAttributesReport: React.FC<any> = (props) => {
  const { handleAddModal, openAddModal, getList } = props;

  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();

  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = (data) => {
    setLoading(true);
    let from_date: string = "";
    let to_date: string = "";

    if (from_date) {
      from_date = dayjs(data?.from_date).format("YYYY-MM-DD");
    }
    if (to_date) {
      to_date = dayjs(data?.to_date).format("YYYY-MM-DD");
    }

    const payload = {
      limit: data?.limit,
      offset: data?.offset,
      number_type: data?.number_type,
      from_date: from_date ?? "",
      to_date: to_date ?? "",
    };

    dispatch(addNumberManagementNumberAttributesReport(payload))
      .then((res: any) => {
        handleAddModal();
        getList();
      })
      .catch((error: any) => {
        console.log("error", error);

        // handleAddModal();
        // getList();
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  const disabledDate = (current: Dayjs) => {
    // Can not select days after today
    return current && current.isAfter(dayjs().endOf("day"));
  };

  return (
    <Modal
      open={openAddModal}
      destroyOnClose
      width={900}
      onCancel={handleAddModal}
      closeIcon={<FontAwesomeIcon icon={faTimes} />}
      footer={false}
      className="addModal"
      title={`Add Number Management Number Attributes Report`}
    >
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
      >
        <Row gutter={20} align={"middle"}>
          <Col xs={24} md={8}>
            <InputBox.Text
              label="Limit"
              name={"limit"}
              type="number"
              tooltip="How many records to provide"
              defaultValue={50}
              initialValue={50}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Text
              label="offset"
              name={"offset"}
              type="number"
              tooltip="What page to provide"
              defaultValue={0}
              initialValue={0}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.DatePicker
              label="Select From Date"
              name={"from_date"}
              placeholder={"Select From Date"}
              format={CONSTANT.POST_DATE_FORMAT}
              disabledDate={disabledDate}
              onChange={handleChange}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.DatePicker
              label="Select To Date"
              name={"to_date"}
              placeholder={"Select To Date"}
              format={CONSTANT.POST_DATE_FORMAT}
              disabledDate={disabledDate}
              onChange={handleChange}
            />
          </Col>
          <Col xs={24} md={8}>
            <InputBox.Select
              required
              label="Number Type"
              name={"number_type"}
              allowClear
              showSearch
              placeholder="Select Number Type"
              tooltip="Select Number Type"
              options={{
                list: [
                  {
                    id: "mobile",
                    label: "Mobile",
                  },
                  {
                    id: "fixed",
                    label: "Fixed",
                  },
                  {
                    id: "both",
                    label: "Both",
                  },
                ],
                valueKey: "id",
                textKey: "label",
              }}
              rules={[
                { required: true, message: "Please Select Number Type." },
              ]}
            />
          </Col>
        </Row>
        <Row gutter={[20, 20]} className="mt-20">
          <Col xs={12} md={12} lg={6}>
            <Button type="primary" htmlType="submit" loading={loading}>
              <SVGIcon icon="add" color="#fff" width={55} /> Add Report
            </Button>
          </Col>
          <Col xs={12} md={12} lg={6}>
            <Button
              type="default"
              onClick={() => {
                form.resetFields();
                // if (typeAction === "daily") {
                //   form.setFieldsValue({ report_date: dayjs(new Date()) });
                // }
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </Modal>
  );
};

export default AddNumberAttributesReport;
